export default __webpack_public_path__ + "static/media/amazon-dns.49b58d3e.png";